import React from 'react';
import loadable from '@loadable/component';
import {lazy} from '../../../templates/helpers';
import {IS_BROWSER, withRenderStrategy} from '../../../utils/dynamic-rendering';

const LoadableSeoLinkpile = loadable(() =>
    import(
        /* webpackChunkName: "seo-linkpile" */
        './SeoLinkpile'
    )
);

const BaseDynamicSeoLinkpile = ({ssr, ...rest}) => {
    const element = <LoadableSeoLinkpile {...rest} />;

    if (ssr) {
        return element;
    }

    if (IS_BROWSER) {
        return lazy(element);
    }

    return null;
};

const DynamicSeoLinkpile = withRenderStrategy(BaseDynamicSeoLinkpile);

DynamicSeoLinkpile.displayName = 'DynamicSeoLinkpile';

export default DynamicSeoLinkpile;
